<div>
    <button 
    #buttonElement
    class="btn"
    (click)="onClick()"
    [class.btn-outline-primary]="!isLoading"
    [class.btn-primary]="isLoading"
    [ngbTooltip]="tipContent"
    [disabled]="isLoading"
    tooltipClass="custom-tooltip"
    type="button">
    <i *ngIf="isSuccess; else normalState" class="icofont icofont-verification-check"></i>
    <ng-template #normalState>
        <i class="icofont icofont-refresh" [ngClass]="{ 'loading': isLoading }"></i>
    </ng-template>
    </button>
    <ng-template #tipContent>
    {{ 'cachedAt' | translate }}
    <span class="date-content">{{ date | localizedDate : 'short' }}</span>
    </ng-template>
</div>